import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import PackerDeliveryOrderBatchRefundItem from './packerDeliveryOrderBatchRefundItem';
import utils from '../../utils/utils';
import PackerRefundForm from './packerRefundForm';
import { useQueryClient } from 'react-query';

const PackerRefunds = ({
  refundOrderItems,
  setRefundOrderItems,
  updateRefundOrderItem,
  removeFromRefunds,
  user,
  orderBatchId,
  refunds,
  invalidateQueryKey,
}) => {
  const [showRefundPopup, setShowRefundPopup] = useState(false);
  const queryClient = useQueryClient();

  return (
    <>
      {refundOrderItems.length ? (
        <>
          <h4 className="text-success">
            <FormattedMessage id={'packer.delivery.order.batch.row.refunds.header'} />
          </h4>
          <div className="m-b-1">
            {refundOrderItems.map((roi, index) => {
              return (
                <PackerDeliveryOrderBatchRefundItem
                  key={index}
                  updateRefundOrderItem={(newRoi) => updateRefundOrderItem(newRoi, index)}
                  removeRefundOrderItem={() => removeFromRefunds(index)}
                  refundOrderItem={roi}
                />
              );
            })}
          </div>
          <div className="m-b-2">
            <strong>
              <FormattedMessage id={'packer.delivery.order.batch.row.refunds.total'} />:{' '}
              {utils.getRoundedPrice(
                refundOrderItems.reduce((result, roi) => {
                  return result + roi.amount;
                }, 0)
              )}
              €
            </strong>
          </div>
          <div className="m-b-3">
            <button className="btn btn-default" onClick={() => setShowRefundPopup(true)}>
              <FormattedMessage id={'packer.delivery.order.batch.row.refunds.cta'} />
            </button>
          </div>
        </>
      ) : (
        ''
      )}

      {refunds.length ? (
        <div className="m-b-3">
          <h5 className="text-muted">
            <FormattedMessage id={'packer.delivery.order.batch.row.existing.refunds.header'} />
          </h5>

          {refunds.map((refund) => (
            <div key={refund.id}>
              {refund.amount}€ - "{refund.comment}"
            </div>
          ))}
        </div>
      ) : (
        ''
      )}

      <Modal show={!!showRefundPopup} onHide={() => setShowRefundPopup(false)} size="lg">
        <div onClick={() => setShowRefundPopup(false)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {showRefundPopup ? (
            <PackerRefundForm
              refundOrderItems={refundOrderItems}
              user={user}
              orderBatchId={orderBatchId}
              updateRefundOrderItem={updateRefundOrderItem}
              removeRefundOrderItemFromIndex={removeFromRefunds}
              closeModal={() => {
                setShowRefundPopup(false);
                setRefundOrderItems([]);
                queryClient.invalidateQueries(invalidateQueryKey);
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
    </>
  );
};

PackerRefunds.propTypes = {};

PackerRefunds.defaultProps = {};

export default PackerRefunds;
